import { FC, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { AppLayout } from '../AppLayout';
import styles from './Page.module.scss';

import { BreadcrumbItem } from '../TopHeader';

export interface PageProps {
  meta: {
    title: string;
    description: string;
  };
  children?: ReactNode;
  clsPage?: string;
  fullWidth?: boolean;
  breadcrumbs?: BreadcrumbItem[];
  searchPlaceholder?: string;
}

export const Page: FC<PageProps> = ({
  meta,
  children,
  clsPage = '',
  breadcrumbs,
  searchPlaceholder,
}) => {
  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className={`${styles.pageWrapper} ${clsPage}`}>
        <AppLayout breadcrumbs={breadcrumbs} searchPlaceholder={searchPlaceholder}>
          {children}
        </AppLayout>
      </div>
    </>
  );
};

export const withPage =
  (Component: FC) => (pageProps: Omit<PageProps, 'children'>) => () => (
    <Page {...pageProps}>
      <Component />
    </Page>
  );

